import {Component, inject, OnInit, signal} from '@angular/core';
import {CommonDropdownComponent} from '@lib-ui/common-dropdawn/common-dropdown.component';
import {MatButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MessageService} from '@lib-services/message.service';
import {IGroup, IGroupCreate, IGroupUpdate} from '@lib-typing/group.interface';
import {GroupsService} from '@lib-services/groups.service';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import {Group} from '@libs-classes/group.class';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {LocationSelectorService} from '@lib-services/location-selector.service';
import {filter, switchMap} from 'rxjs';
import { CloseButtonComponent } from '@lib-ui/close-button/close-button.component';

@Component({
    selector: 'app-company-form',
    standalone: true,
    imports: [
        CommonDropdownComponent,
        MatButton,
        MatFormField,
        MatInput,
        MatLabel,
        ReactiveFormsModule,
        MatDialogContent,
        LoaderComponent,
        CloseButtonComponent,
        MatDialogTitle,
    ],
    templateUrl: './group-form.component.html',
    styleUrl: './group-form.component.scss'
})
export class GroupFormComponent implements OnInit{
    groupForm: FormGroup;
    group = new Group({} as IGroup);
    loading = signal(false);
    public data: { groupId?: number } = inject(MAT_DIALOG_DATA);

    constructor(
        private fb: FormBuilder,
        private groupsService: GroupsService,
        // protected companySelectorService: CompanySelectorService,
        protected locationSelectorService: LocationSelectorService,
        private messageService: MessageService,
        protected dialogRef: MatDialogRef<GroupFormComponent>
    ) {
        this.groupForm = this.fb.group({
            name: ['', Validators.required],
            // companyId: [null, Validators.required],
            locationId: [null, Validators.required],
        });
    }

    ngOnInit(): void {
        if (this.data.groupId) {
            this.loading.set(true);
            this.groupsService.getGroup(this.data.groupId).subscribe( {
                next: data => {
                    this.group.data = data;
                    this.groupForm.patchValue(this.group.formData());
                },
                error: error => {this.messageService.errorMessage(error.message);}
            }).add(() => this.loading.set(false));
        }
    }

    // get companyControl(): FormControl {
    //     return this.groupForm.get('companyId') as FormControl;
    // }

    get locationControl(): FormControl {
        return this.groupForm.get('locationId') as FormControl;
    }

    onSubmit(): void {
        if (!this.groupForm.valid) {
            return;
        }

        this.loading.set(true);
        const request = this.group.data.id
            ? this.groupsService.updateGroup(this.group.dataForUpdate(this.groupForm.value as IGroupUpdate))
            :  this.groupsService.createGroup(this.group.dataForCreate(this.groupForm.value as IGroupCreate));

        request.subscribe({
            next: result => {
                this.messageService.successMessage('Группа успешно сохранена');
                this.dialogRef.close(result);},
            error: error => {this.messageService.errorMessage(error.message);}
        }).add(() => this.loading.set(false));
    }

    deleteGroup(id: number): void {
        this.messageService.confirmMessage({
            title: 'Удаление группы',
            text: 'Вы действительно хотите удалить группу?',
            primaryText: 'Удалить',
            secondaryText: 'Отмена',
            showSecondaryButton: true,
        }).pipe(
            filter(result => result),
            switchMap(() => {
                return this.groupsService.deleteGroups([id]);
            }),
        ).subscribe({
            next: () => {
                this.messageService.successMessage('Группа успешно удалена');
                this.dialogRef.close(true);
            },
            error: () => this.messageService.errorMessage('При удалении произошла ошибка')
        });
    }
}
